if(!customElements.get('custom-video')){
    class CustomVideo extends HTMLElement {
        constructor(){
            super();
    
            this.init();
        }

        init(){
            this.video = this.querySelector('#video__media');
            this.videoWrapper = this.querySelector('.inline-video');
            this.videoSrc = this.querySelector('.inline-video').dataset.src;
    
            this.playBtn = this.querySelector('.btn-play');
            this.playBtn.addEventListener('mouseover', () => {
                this.setAttribute('data-hover', 'true');
            })
            this.playBtn.addEventListener('mouseout', () => {
                this.setAttribute('data-hover', 'false');
            })
    
            this.playBtn.addEventListener('click', this.playVideo.bind(this));
    
            this.adjustMaxHeight();
        }
    
        playVideo(){
            var newSrc = this.video.dataset.src;
    
            if(newSrc){
                if(this.video.dataset.type == 'youtube'){
                    this.video.setAttribute('src', newSrc + '&autoplay=1&amp;modestbranding=1&amp;showinfo=0&amp;rel=0');
                }else{
                    this.video.setAttribute('src', newSrc + '?autoplay=1&amp;modestbranding=1&amp;showinfo=0&amp;rel=0');
                }
    
                this.setAttribute('data-play', 'true');
            }
        }
    
        adjustMaxHeight(){
            var header = document.querySelector('custom-header');
            if(header){
                setTimeout(() => {
                    var headerHeight = header.offsetHeight;
                    if(document.querySelector('custom-announcement-bar')){
                        headerHeight += document.querySelector('custom-announcement-bar').offsetHeight;
                    }
                    this.style.maxHeight = 'calc(100vh - ' + headerHeight + 'px)';
                    this.querySelector('iframe').style.maxHeight = 'calc(100vh - ' + headerHeight + 'px)';
                }, 500)
            }
        }
    }
    
    customElements.define('custom-video', CustomVideo);
}